import React, { useState, useEffect, useRef, useContext } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import { accountService, alertService, config, lockerService } from '../../_services';
import Dialog from 'react-bootstrap-dialog';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { isActiveReservation, getReservationEndDateTime } from '../../_helpers/reservations';

function AdminCompartment({ history, match }) {

    let open_dialog = useRef(null);

    const { id } = match.params;
    const [submittingRefund, setSubmittingRefund] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isEnablingDisabling, setIsEnablingDisabling] = useState(false);
    const [isOpeningLocker, setIsOpeningLocker] = useState(false);
    const [isChangingCode, setIsChangingCode] = useState(false);

    const [locker, setLocker] = useState({
        id: '',
        lockerType: '',
        lockerTypeId: '',
        venue: '',
        guiAdmin: '',
        isEnabled: '',
        reservationId: ''
    });
    const [reservation, setReservation] = useState({
        id: '',
        lockerType: '',
        startDate: '',
        endDate: '',
        venue: '',
        area: '',
        isEnded: '',
        accountEmail: '',
        orderNumber: ''
    });
    const { t } = useTranslation();
    async function fetchData() {
        setIsLoading(true);
        const locker = await lockerService.getById(id);
        console.log(locker);
        setLocker(locker);
        if (await isActiveRental(locker)) {
            setReservation(locker.reservation);
        } else {
            locker.reservationId = "";
            setLocker(locker);
        }
        setIsLoading(false);
    }
    
    useEffect(() => {
        
        fetchData();
    }, [id]);

    const validationSchema = Yup.object().shape({

    });
    async function enable_disable(state, gui_admin, venue) {
        var result;
        locker.isEnablingDisabling = true;
        setIsEnablingDisabling(true);
        if (state) {
            await lockerService.disableLocker(gui_admin, venue).then(
                (data) => {
                    console.log(data);
                    result = data.message;
                    locker.isEnablingDisabling = false;
                }
            ).catch(err => { console.log(err); result = err; });
            alert("Disable locker " + gui_admin + " at " + venue + " result: " + result);
            setIsEnablingDisabling(false);

        } else {
            await lockerService.enableLocker(gui_admin, venue).then(
                (data) => {
                    console.log(data);
                    result = data.message;
                    locker.isEnablingDisabling = false;
                }
            ).catch(err => { console.log(err); result = err });
            alert("Enable locker " + gui_admin + " at " + venue + " result: " + result);
            setIsEnablingDisabling(false);
        }
        fetchData();
    }

    async function isActiveRental(locker) {
        if (locker.reservationId == "") {
            console.log("No reservation")
            return false;
        }
        const reservation = await accountService.getReservationById(locker.reservationId);
        console.log("Reservation: ", reservation);
        if (!isActiveReservation(reservation)) {
            return false;
        }
        locker.reservation = reservation;
        setLocker(locker);
        return true;
    }

    function openLocker( gui_admin,venue, message_text) {
        open_dialog.show({
            bsSize: 'lg',
            body: message_text + gui_admin + " ?",

            actions: [
                Dialog.CancelAction(() => {
                    locker.isOpeningLocker = false;
                    setIsOpeningLocker(false);
                }),
                Dialog.OKAction(() => {
                    lockerService.bypassOpen(gui_admin, venue).then((data) => {
                        locker.isOpeningLocker = false;
                        setIsOpeningLocker(false);
                    }).catch(err => {
                        alertService.error(err);
                        locker.isOpeningLocker = false;
                        setIsOpeningLocker(false);
                    });
                    locker.isOpeningLocker = true;
                    setIsOpeningLocker(true);
                })
            ]
        });
    }
    // TODO: Implement refunds for kiosk rentals
    function refundReservation(id) {
        if (reservation.accountEmail == "tiburontss@tiburonlockers.com") {
            alert("This Rental was made from Kiosk. Refund must be done from Kiosk.");
            return;
        }
        let confirmed = window.confirm('Are you sure?');
        console.log(confirmed);
        if (confirmed) {
            setSubmittingRefund(true);
            accountService.refundReservation(id)
                .then(() => { setSubmittingRefund(false); alertService.success('Reservation refunded!') })
                .catch(error => { setSubmittingRefund(false); alertService.error(error) });
        }
        fetchData();
    }

    function changeAccessCode(guiAdmin, venue) {
        open_dialog.show({
            bsSize: 'lg',
            body: (
                <div>
                    <p>Enter new access code:</p>
                    <input type="tel" pattern="[0-9]*" maxLength={4} id="newAccessCode" className="form-control" />
                </div>
            ),
            actions: [
                Dialog.CancelAction(() => {
                    setIsChangingCode(false);
                }),
                Dialog.OKAction(() => {
                    const newCode = document.getElementById('newAccessCode').value;
                    if (/^\d+$/.test(newCode)) { // Check if the input is a number
                        console.log("CHANGE PIN: ", guiAdmin, venue, newCode);
                        setIsChangingCode(true);
                        lockerService.changeAccessCode(guiAdmin, venue, newCode)
                            .then((result) => {
                                console.log("CHANGE PIN RESULT: ", result);
                                if (result.status == "True") {
                                    alertService.success('Access code changed!');
                                } else {
                                    alertService.error('Error changing access code');
                                }
                                setIsChangingCode(false);
                            })
                            .catch(error => { alertService.error(error); setIsChangingCode(false); } );
                    } else {
                        alertService.error('Invalid access code. Please enter numbers only.');
                    }
                })
            ]
        });
    }


    function reassignLocker() {
        history.push(`/lockers-admin/kiosks/reassign/${locker.id}`);
    }

    function todo(id, gui_admin, message_text) {

        alert("This functionality is not yet implemented. ID:" + id + " guiadmin:" + gui_admin + " -- " + message_text)

    }

    function onSubmit(fields, { setStatus, setSubmitting }) {
        setStatus();
        alertService.success('Update Locker Here', { keepAfterRouteChange: true });
        //updateLocker(id, fields, setSubmitting);

    }

    const end_date_and_time = () => {
        var end_time_string;
        if (typeof (accountService.configValue['eobDisplay']) !== 'undefined') {
            var d = new Date(moment(reservation.endDate).format('YYYY-MM-DD') + " " + accountService.configValue['eobDisplay']);
            end_time_string = d.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });

        } else {

            end_time_string = " end of business day";
        }
        // end date in UI is the last day of rental at closing time but end date in db is day after?
        // i.e. a 2 day rental starting today ends tomorrow at close so we add 1 to today not the number of days rented
        var end_date = moment(reservation.endDate).add( -1, 'days').format('YYYY-MM-DD');
        return end_date + " at " + end_time_string;
    }

    return (
        <>
        <div class="card m-3">
            {isLoading && <div className="spinner-border spinner-border-lg"></div>}

            {!isLoading && <>
            <div className="card-header header-admin admin-top-bdr">
                <h2 className="bold-tx">{locker.venue} </h2>
                <h2 className="bold-tx"> Locker #: {locker.guiAdmin}</h2>
                <h4>Size: {locker.lockerType} </h4>
                <h4>Enabled: {locker.isEnabled ? "True" : "False"}</h4>
            </div>
            <div className="card d-flex flex-column align-items-center my-2">
                {locker.reservationId != "" &&
                    <>
                        <p className=" rent-agree-marg">
                            Reserved By: {reservation.accountEmail != "tiburontss@tiburonlockers.com" ? reservation.accountEmail : "Kiosk User"}
                            <br />
                            Start Date: {reservation.startDate}
                            <br />
                            {accountService.configValue['multiDay'] === 'true' && 
                                <>
                                End Date: {getReservationEndDateTime(reservation).format('YYYY-MM-DD HH:mm')}
                                </>
                            }
                        </p>
                    </>
                }
                    <button
                        onClick={(e) => { openLocker(locker.guiAdmin,locker.venue,t('Open Locker #')) }}
                        className="btn btn-sm btn-success mb-2"
                        style={{  width: '45%' }}
                        disabled={isOpeningLocker}>
                        {isOpeningLocker
                            ? <span className="spinner-border spinner-border-sm"></span>
                            : <span>{t('Open')}</span>
                        }
                    </button>
                {locker.reservationId != "" &&
                    <>

                        <button
                            onClick={() => { reassignLocker() }}
                        className="btn btn-sm btn-primary blue-btn-edit mb-2"
                            style={{ width: '45%' }}
                            disabled={reservation.isReassigningLocker}>
                            {reservation.isReassigningLocker
                                ? <span className="spinner-border spinner-border-sm"></span>
                                : <span>{t('Reassign')}</span>
                            }
                        </button>

                        <button
                            onClick={(e) => { changeAccessCode(locker.guiAdmin, locker.venue, t('CHANGE ACCESS CODE')) }}
                        className="btn btn-sm btn-primary blue-btn-edit mb-2"
                            style={{ width: '45%' }}
                            disabled={isChangingCode}>
                            {isChangingCode
                                ? <span className="spinner-border spinner-border-sm"></span>
                                : <span>{t('Change Access Code')}</span>
                            }
                        </button>

                        <button
                        onClick={(e) => { refundReservation(reservation.id) }}
                            className="btn btn-sm btn-danger mb-2"
                            style={{ width: '45%' }}
                            disabled={submittingRefund}>
                            {submittingRefund
                                ? <span className="spinner-border spinner-border-sm"></span>
                                : <span>{t('Refund')}</span>
                            }
                        </button>

                    </>
                }
                {locker.reservationId == "" && 
                    <button
                        onClick={(e) => { enable_disable( locker.isEnabled, locker.guiAdmin, locker.venue) }}
                        className="btn btn-sm btn-danger blue-btn-edit mb-2"
                        style={{ width: '45%' }}
                        disabled={isEnablingDisabling}>
                        {isEnablingDisabling
                            ? <span className="spinner-border spinner-border-sm"></span>
                            : <span>{locker.isEnabled ? t('Disable') : t('Enable')}</span>
                        }
                    </button>
                }

            </div>
            <div className="card-footer admin-btm-bdrline">
        
                <Link onClick={() => history.goBack()}>Back</Link>
                <br />
                <Link className="btn btn-link" to={`/lockers-admin`} >Admin</Link>
                <br />
            </div>

            <Dialog ref={(el) => { open_dialog = el }} />

                </>}
            </div>
        </>

    );

}

export { AdminCompartment };